<app-page-transition>
  <div class="app-container">
    <div class="ws-blocker" *ngIf="(isConnected$ | async) === false">
      <div class="ws-blocker__content" role="status" aria-live="polite" [attr.aria-label]="'nav.connecting' | translate">
        <div class="ws-blocker__spinner"></div>
        <div class="ws-blocker__text">{{ 'nav.connecting' | translate }}</div>
      </div>
    </div>
    <div class="app-header">
      <div class="header-left">
        <a routerLink="/" class="home-link">
          <h1>RSS Front</h1>
        </a>
        <div *ngIf="environment.env === 'test'" class="test-indicator">TEST</div>        
        <div *ngIf="environment.env === 'dev'" class="test-indicator">DEV</div>        
      </div>
      <div class="header-left">
        <div class="version-info" [title]="'nav.app_version' | translate">v{{ version }}</div>
      </div>
      <div class="header-right">
        <button class="fw-button" (click)="firmware()" [title]="'nav.firmware' | translate" [attr.aria-label]="'nav.firmware' | translate">
          <!-- <img src="assets/icons/fw.svg" width="28" height="28"/>   -->
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon">
            <path d="M21 8H17.8174M21 12H18M21 16H17.8174M6.18257 8H3M8 6.18257V3M8 21L8 17.8174M12 6V3M12 21V18M16 6.18257V3M16 21V17.8174M6 12H3M6.18257 16H3M10.8 18H13.2C14.8802 18 15.7202 18 16.362 17.673C16.9265 17.3854 17.3854 16.9265 17.673 16.362C18 15.7202 18 14.8802 18 13.2V10.8C18 9.11984 18 8.27976 17.673 7.63803C17.3854 7.07354 16.9265 6.6146 16.362 6.32698C15.7202 6 14.8802 6 13.2 6H10.8C9.11984 6 8.27976 6 7.63803 6.32698C7.07354 6.6146 6.6146 7.07354 6.32698 7.63803C6 8.27976 6 9.11984 6 10.8V13.2C6 14.8802 6 15.7202 6.32698 16.362C6.6146 16.9265 7.07354 17.3854 7.63803 17.673C8.27976 18 9.11984 18 10.8 18ZM10 10H14V14H10V10Z"/>
          </svg>            
        </button>
        <button class="add-controller-button" (click)="linkController()" [title]="'nav.link_controller' | translate" [attr.aria-label]="'nav.link_controller' | translate">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
        <div class="user-info profile-menu">
          <button
            class="profile-button"
            type="button"
            (click)="toggleProfileMenu($event)"
            [attr.aria-expanded]="profileMenuOpen"
            aria-haspopup="menu"
            [attr.aria-label]="'nav.profile_menu' | translate"
          >
            <app-icon name="user"></app-icon>
          </button>
          <ul *ngIf="profileMenuOpen" class="profile-dropdown" role="menu" (click)="$event.stopPropagation()">
            <li role="menuitem" (click)="toggleTheme()">
              <ng-container *ngIf="themeService.darkMode$ | async; else darkThemeLabel">{{ 'nav.theme.light' | translate }}</ng-container>
              <ng-template #darkThemeLabel>{{ 'nav.theme.dark' | translate }}</ng-template>
            </li>
            <!-- Three-way, so chips rather than the theme row's toggle. -->
            <li class="lang-row" role="group" [attr.aria-label]="'nav.language' | translate">
              <button *ngFor="let l of langs"
                      type="button"
                      class="lang-chip"
                      [class.active]="l.code === (localeService.lang$ | async)"
                      [attr.aria-pressed]="l.code === (localeService.lang$ | async)"
                      (click)="setLang(l.code)">{{ l.label }}</button>
            </li>
            <li role="menuitem" (click)="telegram()">{{ 'nav.telegram' | translate }}</li>
            <li role="menuitem" (click)="logout()">{{ 'nav.logout' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</app-page-transition>